import React from "react";
import "./EventsPage.css";
import Footer from "./footer";

const events = [
  {
    id: 1,
    title: "نمایشگاه صنایع دستی کرکوک عراق",
    date: "بهمن 1402",
    description: "حضور پررنگ هنرمندان ایرانی و معرفی اصالت هنرهای سنتی در جمعی بین‌المللی",
    image: "/images/events/event1.png"
  },
  {
    id: 2,
    title: "نکوداشت روز جهانی صنایع دستی",
    description: "گرامیداشت میراث فرهنگی و هنری ایران در کنار هنرمندان و علاقه‌مندان این عرصه",
    image: "/images/events/event2.png"
  },
  {
    id: 3,
    title: "لوح سپاس و تقدیر از هنرمندان صنایع دستی",
    description: "نشانی از ارزش‌آفرینی و خلاقیت هنرمندان در اعتلای فرهنگ و هنر ایرانی",
    image: "/images/events/event3.png"
  },
  {
    id: 4,
    title: "پیشینۀ ملی و بین‌المللی در صنایع دستی",
    description: "سال‌ها تجربۀ درخشان در عرصۀ صنایع دستی و کسب افتخارات ملی و بین‌المللی",
    image: "/images/events/event4.png"
  }
];

const EventsPage = () => {
  return (
    
    <div className="events-page" style={{ cursor: "url('/images/shell.png'), auto" }}>

      
      {/* Hero Section */}
    
      <div className="events-hero">
        <h1>نمایشگاه‌ها</h1>
        <p>
          صنایع دستی ما حاصل ذوق، هنر و میراث نسل‌های گذشته است. افتخار ما در طی سال‌ها، کسب اعتماد مشتریان و دریافت تقدیرنامه‌ها و گواهینامه‌های معتبر ملی و بین‌المللی بوده است. هر نشان افتخار، یادآور تلاش هنرمندان ما برای حفظ اصالت و در عین حال ارائه‌ی محصولی باکیفیت و ماندگار است.
        </p>
      </div>

      {/* Events Grid */}
      <div className="events-grid">
        {events.map(event => (
          <div key={event.id} className="event-card">
            <div className="event-image">
              <img src={event.image} alt={event.title} />
            </div>
            <div className="event-content">
              <h3>{event.title}</h3>
              <span className="event-date">{event.date}</span>
              <p>{event.description}</p>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default EventsPage;
